export default {
  root: {
    borderTop: '1px solid rgba(140, 140, 140, 0.1)',
    height: 70,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    /**
     * The theme editor should not be editable so hard-code the glu colors
     */
    '& button:first-child': {
      marginRight: 7,
      borderColor: '#0070B9',
      backgroundColor: '#0070B9',
      color: '#fff'
    },
    '& button': {
      marginLeft: 7,
      borderColor: '#0070B9',
      backgroundColor: '##fff',
      color: '#0070B9'
    },
    '& input[type="file"]': {
      display: 'none'
    }
  }
};
